import './Politicas.css';
import Navbar from '../Navbar/Navbar';

const Politicas = () => {
  return (
    <>
      <Navbar />
      <div className="politicas container">
        <h1>Política de Privacidad de Lancaster</h1>
        <p>Fecha de efectividad: 04/04/2024</p>

        <p>En Lancaster, valoramos su privacidad y nos comprometemos a proteger la información personal que nos proporciona. Esta política de privacidad explica cómo recopilamos, usamos y compartimos su información personal al utilizar nuestros servicios, incluyendo llamadas con inteligencia artificial, CRM e integración opcional con Google Calendar. Por favor, lea esta política cuidadosamente para entender nuestras prácticas respecto a su información personal.</p>

        <section>
          <h2>1. Información que Recopilamos</h2>
          <p>Podemos recopilar información personal que nos proporciona directamente, como su nombre, correo electrónico y cualquier otra información que decida proporcionar durante el uso de nuestros servicios. Además, cuando interactúa con Lancaster, recopilamos el contenido de esas interacciones. Si decide conectar Google Calendar, también podremos recopilar y almacenar la información técnica necesaria para mantener esa conexión, así como la información del calendario autorizada por usted para consultar disponibilidad y administrar citas o eventos desde la plataforma.</p>
        </section>

        <section>
          <h2>2. Uso de la Información</h2>
          <p>Utilizamos la información recopilada para proporcionar, mantener y mejorar nuestros servicios, para responder a sus consultas o para cualquier otro propósito con su consentimiento. En caso de que conecte Google Calendar, utilizamos esa información únicamente para habilitar la integración, consultar disponibilidad, administrar eventos o citas y sincronizar esa información dentro de Lancaster. No utilizamos la información obtenida desde Google Calendar para fines publicitarios.</p>
        </section>

        <section>
          <h2>3. Compartir Información</h2>
          <p>No vendemos ni compartimos su información personal ni la información obtenida a través de Google Calendar con terceros para sus propios fines comerciales sin su consentimiento explícito, excepto en los casos permitidos por la ley.</p>
        </section>

        <section>
          <h2>4. Integración con Google Calendar</h2>
          <p>La conexión con Google Calendar es opcional y solo se realiza cuando usted la autoriza. Esta integración permite a Lancaster consultar disponibilidad y administrar citas o eventos dentro de la plataforma. Puede desconectar Google Calendar desde su cuenta de Lancaster en cualquier momento.</p>
        </section>

        <section>
          <h2>5. Seguridad de la Información</h2>
          <p>Implementamos medidas de seguridad técnicas y organizativas para proteger la información personal que recopilamos y mantenemos. Sin embargo, ningún sistema de seguridad es impenetrable, y no podemos garantizar la seguridad de nuestra base de datos.</p>
        </section>

        <section>
          <h2>6. Cambios a esta Política de Privacidad</h2>
          <p>Podemos modificar esta política de privacidad ocasionalmente. Publicaremos cualquier cambio en esta página, y si los cambios son significativos, proporcionaremos un aviso más destacado.</p>
        </section>

        <section>
          <h2>7. Exención de Responsabilidad de Lancaster</h2>
          <p>Lancaster es una herramienta de comunicación automatizada que proporciona respuestas y automatizaciones basadas en la información y consultas que recibe. Aunque nos esforzamos por asegurar que el contenido y las acciones ejecutadas por la plataforma sean útiles y relevantes, no nos hacemos responsables de respuestas generadas automáticamente o de acciones ejecutadas con información incompleta o incorrecta proporcionada por el Usuario. El uso de estas funcionalidades es a su propio riesgo.</p>
        </section>

        <section className="footer">
          <h2>8. Contacto</h2>
          <p>Si tiene alguna pregunta sobre esta política de privacidad o nuestros tratamientos de su información personal, por favor contáctenos en <a href="mailto:bob0011@hotmail.com">bob0011@hotmail.com</a>.</p>
        </section>
      </div>
    </>
  );
};

export default Politicas;
